const LOCAL_PART_SPECIAL_CHARS = ".!#$%&'*+-/=?^_`{|";

export const isValidLocalChar = (char: string): boolean => {
  if (/[a-zA-Z0-9]/.test(char)) return true;
  return LOCAL_PART_SPECIAL_CHARS.includes(char);
};

export const isValidDomainChar = (char: string): boolean => {
  return /[a-zA-Z0-9.-]/.test(char);
};

export const filterEmailInput = (value: string): string => {
  let filtered = value.replace(/^\s+|\s+$/g, '');
  
  filtered = filtered.replace(/\s/g, '');
  
  const atIndex = filtered.indexOf('@');
  
  if (atIndex === -1) {
    filtered = filtered
      .split('')
      .filter(char => isValidLocalChar(char))
      .join('');
  } else {
    const localPart = filtered.substring(0, atIndex)
      .split('')
      .filter(char => isValidLocalChar(char))
      .join('');
    
    const domainPart = filtered.substring(atIndex + 1)
      .split('')
      .filter(char => isValidDomainChar(char))
      .join('');
    
    filtered = localPart + '@' + domainPart;
  }
  
  return filtered.substring(0, 256);
};

export const validateEmailFormat = (email: string): boolean => {
  if (!email || email.length === 0) return false;
  
  const trimmed = email.trim();
  
  const atIndex = trimmed.indexOf('@');
  if (atIndex === -1 || atIndex === 0 || atIndex === trimmed.length - 1) {
    return false;
  }
  
  const localPart = trimmed.substring(0, atIndex);
  const domainPart = trimmed.substring(atIndex + 1);
  
  if (localPart.length === 0) return false;
  
  if (LOCAL_PART_SPECIAL_CHARS.includes(localPart[0]) || 
      LOCAL_PART_SPECIAL_CHARS.includes(localPart[localPart.length - 1])) {
    return false;
  }
  
  for (let i = 0; i < localPart.length - 1; i++) {
    const char = localPart[i];
    const nextChar = localPart[i + 1];
    if (LOCAL_PART_SPECIAL_CHARS.includes(char) && 
        LOCAL_PART_SPECIAL_CHARS.includes(nextChar)) {
      return false;
    }
  }
  
  if (domainPart.length === 0) return false;
  
  if (!domainPart.includes('.')) return false;
  
  if (!/^[a-zA-Z0-9.-]+$/.test(domainPart)) return false;
  
  if (domainPart[0] === '-' || domainPart[domainPart.length - 1] === '-') {
    return false;
  }
  
  return true;
};
